<template>
  <Modal
    class="applyForAddingLabels"
    title="设置标签"
    v-model="show"
    width="1100px"
    footer-hide
    @on-cancel="close"
  >
    <div class="body">
      <div class="left">
        <div class="hander">
          <Select
            v-model="keyword"
            placeholder="搜索标签"
            clearable
            filterable
            @on-change="selectChange"
            default-first-option
          >
            <Option
              v-for="item in filterList"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </Option>
          </Select>
          <Button @click="showApplyForAddingLabels = true">申请标签</Button>
        </div>
        <div class="has-select">
          <div class="title">已选标签</div>
          <span v-for="types in labelTypes" :key="types.labelType">
            <CheckboxGroup
              :key="types.labelType"
              :class="cGroupClass(types)"
              v-model="types.value"
              @on-change="checkbosChang(types, $event)"
            >
              <span
                @click="itemChange(item)"
                v-for="item in labelsFilter(types)"
                :key="item.value"
              >
                <Checkbox
                  :class="['ivu-tag-' + typeList[item.labelType]]"
                  :disabled="isDisabled(item)"
                  border
                  :label="item.labelId"
                  >{{ item.label }}
                  <Icon class="remove-icon" type="ios-close-circle-outline" />
                </Checkbox>
              </span>
            </CheckboxGroup>
          </span>
        </div>
      </div>
      <div class="right">
        <div class="fItem" v-for="types in labelTypes" :key="types.labelType">
          <div class="title">{{ types.labelTypeName }}</div>
          <CheckboxGroup
            :class="cGroupClass(types)"
            v-model="types.value"
            @on-change="checkbosChang(types, $event)"
          >
            <span
              @click="itemChange(item)"
              v-for="(item, index) in types.labels"
              :key="index"
            >
              <Checkbox
                :class="['ivu-tag-' + typeList[item.labelType]]"
                :disabled="isDisabled(item)"
                border
                :label="item.labelId"
                >{{ item.label }}</Checkbox
              >
            </span>
          </CheckboxGroup>
        </div>
      </div>
    </div>
    <setLabel
      ref="setLabelRef"
      :patientInfo="patientInfo"
      @addSuccess="addSuccess"
    />
    <applyForAddingLabels v-model="showApplyForAddingLabels" />
  </Modal>
</template>

<script>
import request from "@/utils/request";
import setLabel from "./setLabel.vue";
export default {
  components: {
    setLabel,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    info: {
      type: Object,
      default: () => ({
        labelTypes: [],
        patientLabels: [],
      }),
    },
    patientInfo: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      showApplyForAddingLabels: false,
      keyword: "",
      labelTypes: [],
      typeList: [
        "",
        "magenta",
        "red",
        "volcano",
        "orange",
        "gold",
        "yellow",
        "lime",
        "green",
        "cyan",
        "blue",
        "geekblue",
        "purple",
        "success",
        "error",
        "warning",
      ],
      itemActive: {},
      show: false,
    };
  },
  watch: {
    value: {
      handler(val) {
        this.init();
      },
      deep: true,
    },
  },
  computed: {
    filterList() {
      let list = [];
      this.labelTypes?.forEach((i) => {
        if (i.labelType != 4) {
          let arr = i.labels.filter((j) => {
            return !i.value.includes(j.value);
          });
          list.push(...arr);
        }
      });
      return this.keyword
        ? list.filter((j) => j.label.indexOf(this.keyword))
        : list;
    },
  },
  methods: {
    labelsFilter(types) {
      return types.labels.filter((i) => types.value.includes(i.labelId));
    },
    cGroupClass(types) {
      return "type-" + this.typeList[types.labelType];
    },
    selectChange(val) {
      let item = this.filterList.find((i) => i.value == val);
      if (item) {
        let item2 = this.labelTypes?.find((i) => i.labelType == item.labelType);
        if (item2) {
          item2.value.push(val);
          this.onSubmit();
        }
      }
      this.$nextTick(() => {
        this.keyword = "";
      });
    },
    itemChange(item, e) {
      this.itemActive = item;
    },
    checkbosChang(item, e) {
      setTimeout(() => {
        if (
          ["病程管理", "不做病案分析", "病程管理第三类人群"].includes(
            this.itemActive.label
          )
        ) {
          let has = e.includes(this.itemActive.value);
          this.$Modal.confirm({
            title: "提示",
            content: `确定${has ? "添加" : "移除"}"${
              this.itemActive.label
            }"吗？`,
            onOk: () => {
              if (this.itemActive.label == "病程管理第三类人群") {
                let obj = {
                  patientCode: this.patientInfo.patientCode,
                  courseCrowdId: has ? 3 : "",
                };
                request.post("base/updatePatientCourseCrowd", obj).then(() => {
                  this.$emit("change");
                });
              } else if (this.itemActive.label == "病程管理") {
                let obj = {
                  patientCode: this.patientInfo.patientCode,
                  courseStatus: has ? 1 : 0,
                };
                request.post("admin/savaDiseaseCourseManage", obj).then(() => {
                  this.$emit("change");
                });
              } else {
                this.onSubmit();
              }
            },
            onCancel: () => {
              item.value = has
                ? item.value.filter((i) => i !== this.itemActive.value)
                : [...item.value, this.itemActive.value];
            },
          });
        } else if (["应筛选患者"].includes(this.itemActive.label)) {
          let has = e.includes(this.itemActive.value);
          if (has) {
            this.$refs.setLabelRef.open(this.getPostData(), item);
          } else {
            this.onSubmit();
          }
        } else {
          this.onSubmit();
        }
      }, 200);
    },
    isDisabled(item) {
      return [
        "安安适用人群",
        "安安（慢病）",
        "安安（非慢病）",
        "老康康",
        "新康康",
      ].includes(item.label);
    },
    close() {
      this.$emit("input", false);
    },
    remove(arr, val) {
      let index = arr.findIndex((i) => i == val);
      arr.splice(index, 1);
    },
    getPostData() {
      return {
        labelIds: this.labelTypes
          ?.reduce((sum, e) => {
            //  idStatus 是否传入编辑接口 1 是 0 否
            let ids = e.labels
              .filter((i) => i.idStatus == 0)
              .map((i) => i.value);
            return sum.concat(e.value.filter((i) => !ids.includes(i)));
          }, [])
          .join(","), //	标签ID 以逗号分隔
        patientCode: this.patientInfo.patientCode, //	患者编码
      };
    },
    onSubmit() {
      request
        .post("/saasbaihui/editPatientLabel", this.getPostData())
        .then((res) => {
          this.$Message.success(res.result);
          this.$emit("change");
        });
    },

    addSuccess() {
      this.$emit("change");
    },

    init() {
      this.show = this.value;
      if (this.show) {
        this.labelTypes = this.common.clone(this.info.labelTypes).map((i) => {
          let idList = [];
          let ids = this.info.patientLabels.map((j) => j.labelId);
          i.labels.forEach((x) => {
            if (ids.includes(x.value)) {
              idList.push(x.value);
            }
          });
          i.value = idList;
          return i;
        });
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped lang="scss">
.applyForAddingLabels {
  :deep {
    .ivu-modal-body {
      height: 70vh;
      overflow-y: auto;
    }
  }
  .title {
    padding-bottom: 10px;
  }
  .hander {
    display: flex;
    .ivu-btn {
      margin-left: 10px;
    }
  }

  .body {
    padding-bottom: 25px;
    display: flex;
    .left {
      width: 300px;
      flex-shrink: 0;
      padding-right: 15px;
      margin-right: 15px;
      border-right: 1px solid var(--el-border-color-light);
      .has-select {
        font-weight: bold;
        padding: 8px 0;
      }
      .ivu-checkbox-group {
        display: inline;
        .ivu-checkbox-wrapper {
          position: relative;
          &:hover {
            .remove-icon {
              display: inline;
            }
          }
          .remove-icon {
            display: none;
            color: #f00;
            position: absolute;
            top: 2px;
            right: 2px;
          }
        }
      }
    }

    .fItem {
      margin-bottom: 15px;

      .Checkbox.is-bordered {
        background: rgba(0, 0, 0, 0.02);
      }

      .Checkbox.is-bordered.is-checked {
        background: #fff;
      }
    }

    :deep {
      label {
        font-weight: 400;
      }
      .ivu-checkbox-inner {
        display: none;
      }
      .ivu-checkbox-wrapper {
        margin-bottom: 10px;
        color: #853a2f;
        background: #ffffff88;
        line-height: 30px;
        border-color: transparent;
      }
      .ivu-checkbox-wrapper-checked.ivu-checkbox-border {
        &.ivu-tag-magenta {
          background: #fff0f6;
          border-color: #ffadd2;
          color: #eb2f96;
        }
        &.ivu-tag-red {
          background: #fff1f0;
          border-color: #ffa39e;
          color: #f5222d;
        }
        &.ivu-tag-volcano {
          background: #fff2e8;
          border-color: #ffbb96;
          color: #fa541c;
        }
        &.ivu-tag-orange {
          background: #fff7e6;
          border-color: #ffd591;
          color: #fa8c16;
        }
        &.ivu-tag-gold {
          background: #fffbe6;
          border-color: #ffe58f;
          color: #faad14;
        }
        &.ivu-tag-yellow {
          background: #feffe6;
          border-color: #fffb8f;
          color: #fadb14;
        }
        &.ivu-tag-lime {
          background: #fcffe6;
          border-color: #eaff8f;
          color: #a0d911;
        }
        &.ivu-tag-green {
          background: #f6ffed;
          border-color: #b7eb8f;
          color: #52c41a;
        }
        &.ivu-tag-cyan {
          background: #e6fffb;
          border-color: #87e8de;
          color: #13c2c2;
        }
        &.ivu-tag-blue {
          background: #e6f7ff;
          border-color: #91d5ff;
          color: #13c2c2;
        }
        &.ivu-tag-geekblue {
          background: #f0f5ff;
          border-color: #adc6ff;
          color: #2f54eb;
        }
        &.ivu-tag-purple {
          background: #f9f0ff;
          border-color: #d3adf7;
          color: #722ed1;
        }
      }
      .ivu-checkbox-wrapper-disabled {
        opacity: 0.6;
      }
      .type-default {
        .Checkbox.is-bordered.is-checked {
          border-color: var(--Checkbox-checked-text-color);
        }
        .Checkbox__input.is-checked + .Checkbox__label {
          color: var(--Checkbox-checked-text-color);
        }
      }
      .type-success {
        .Checkbox.is-bordered.is-checked {
          border-color: var(--el-color-success);
        }

        .Checkbox__input.is-checked + .Checkbox__label {
          color: var(--el-color-success);
        }
      }
      .type-success {
        .Checkbox.is-bordered.is-checked {
          border-color: var(--el-color-success);
        }

        .Checkbox__input.is-checked + .Checkbox__label {
          color: var(--el-color-success);
        }
      }

      .type-warning {
        .Checkbox.is-bordered.is-checked {
          border-color: var(--el-color-warning);
        }

        .Checkbox__input.is-checked + .Checkbox__label {
          color: var(--el-color-warning);
        }
      }

      .Checkbox__inner {
        display: none;
      }

      .Checkbox {
        margin-right: 15px;
        margin-bottom: 10px;
      }
    }
  }

  .is-select-list {
    padding: 15px;
    background: rgba(0, 0, 0, 0.02);
    border: 1px solid #eee;
    border-radius: 5px;
    margin-bottom: 15px;

    .el-tag {
      background: #fff;

      &.el-tag.el-tag--primary {
        border-color: var(--el-color-primary);
      }

      &.el-tag.el-tag--success {
        border-color: var(--el-color-success);
      }

      &.el-tag.el-tag--danger {
        border-color: var(--el-color-danger);
      }
    }

    .item {
      position: relative;
      margin: 0 15px 5px 0;

      .Button {
        padding-right: 20px;
      }

      .el-icon {
        position: absolute;
        top: 4px;
        right: 8px;
        font-size: 12px;

        &:hover {
          background: #f00;
          border-radius: 5px;
          color: #fff;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
